import template from './Tag.vhtml';

export default {
	name: 'Tag',
	template,
	props: {
		color: {
			type: String,
			default: '#999',
		},
	},
};
